<h3>What is the Green-score®?</h3>
<p>
  The <b>Green-score®</b> is an indicator representing the <b>environmental impact</b> of food products. It ranks products into 7 categories from the lowest
  environmental impact <span class="gs-A-plus">A+</span> to the highest impact <span class="gs-F">F</span>.
</p>

<div class="greenscore">
  <!-- <ion-icon src="/assets/svg/dish/green-score/modal/green-score-fr.svg"></ion-icon> -->
  <img src="/assets/svg/dish/green-score/modal/green-score-en.png" alt="Green Score" />
</div>

<h3>How is the Green-score® calculated?</h3>
<p>
  The <b>Green-score®</b> is developed by independent environmental experts and supported by a collective of stakeholders committed to sustainable food.<br />
  The <b>Green-score®</b> is calculated from the <b>environmental impact</b> of a dish and adjusted using <span class="gs-A-plus">BONUSES</span> /
  <span class="gs-F">PENALTIES</span>. This yields a final score out of 100, converted to a letter from <span class="gs-A-plus">A+</span> to
  <span class="gs-F">F</span>.
</p>
<p>Criteria for <span class="gs-A-plus">BONUSES</span> / <span class="gs-F">PENALTIES</span>:</p>
<div class="greenscore-criteria">
  <img src="/assets/svg/dish/green-score/modal/green-score-criteria-en.png" alt="Criteria for BONUSES/PENALTIES" />
</div>

<h3>What is the purpose of the Green-score®?</h3>
<p>
  The <b>Green-score®</b> makes it easy to compare the environmental impact of our recipes to make <b>informed choices</b> about <b>sustainable eating</b>.
</p>

<h3>Where can I find more information about the Green-score®?</h3>
<p>
  If you want to learn more about the Green-score®, you can visit the official website:
  <a href="https://docs.score-environnemental.com/en" target="_blank">https://docs.score-environnemental.com/en</a>
</p>
<footer>
  <p>BETTER UNDERSTANDING IS ALREADY TAKING ACTION</p>
</footer>
